import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { SplitPageLayout } from "shared/components";

export const PasswordRecovery = () => {
  const { loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    loginWithRedirect({
      appState: { returnTo: "/login" },
      authorizationParams: {
        screen_hint: "reset_password",
      },
    }).catch(() => {
      navigate("/login");
    });
  }, [loginWithRedirect, navigate]);

  return (
    <SplitPageLayout
      title='Redirecting to Auth0'
      subtitle='We are redirecting you to Auth0 to reset your password.'
    />
  );
};
